//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { page } from '@/api/pm/budget';
import { Toast } from 'mint-ui';
import { dateTimeFormat } from '@/utils/common';

export default {
	name: 'budgetListPage',
	data() {
		return {
			gobackName: this.$route.params.gobackName,
			projTypeCode : this.$route.params.projTypeCode,
			respDeptCode : this.$route.params.respDeptCode,
			// 查询条件
			listQuery: {
				projCodeName: '',
				respDeptName: '',
				pmName: '',
				status: '',
				currentPage: 1, // 当前页
				pageSize: 5, // 每页数据,
				filter: '0', // 是否需要用户过滤 1：需要 0：不需要
				ids: this.$route.params.ids,
			},
			refreshing: false,
			loading: false,
			listData: []
		}
	},
	created() {
		// 加载数据
		this.loadData();
	},
	computed: {},
	mounted: function() {},
	methods: {
		//时间格式化
		dateFormat: function(date) {
			return dateTimeFormat(date);
		},
		// 返回
		goback() {
			if(this.gobackName == '项目预算总览') {
				if(this.projTypeCode == '005'){
					this.$router.push({
						name: '预算售前人员',
						params: {
							projTypeCode: this.projTypeCode,
							respDeptCode: this.respDeptCode
						}
					});
				}else{
					this.$router.push({
						name: '项目预算总览'
					});
				}
			} else {
				// 返回工作台
				this.$router.push({
					name: 'workbench'
				});
			}
		},
		// 筛选
		filter() {

		},
		// 查找
		searchEvent(event) {
			if(event.keyCode == 13) {
				this.listQuery.currentPage = 1;
				this.loadData();
			}
		},
		// 清空条件
		clearFilter() {
			this.listQuery.projCodeName = '';
			this.listQuery.respDeptName = '';
			this.listQuery.pmName = '';
			this.listQuery.status = '';
			// 当前页重置
			this.listQuery.currentPage = 1;

			this.loadData();
		},
		// 数据刷新(下拉)
		refresh() {
			this.refreshing = true;
			this.$refs.container.scrollTop = 0;

			this.listQuery.currentPage = 1;
			setTimeout(() => {
				// refreshing=true 的情况下加载
				this.loadData();
				this.refreshing = false;
			}, 600);
		},
		// 数据加载(上拉)
		load() {
			this.loading = true;
			setTimeout(() => {
				this.listQuery.currentPage++;
				// 加载
				this.loadData2();
				this.loading = false;
			}, 600);
		},
		// 加载
		loadData() {
			var condition = {
				'condition': JSON.stringify(this.listQuery)
			};
			page(condition).then(response => {
				// 刷新情况下
				this.listData = response.list;
			});
		},
		// 加载数据
		loadData2() {
			var condition = {
				'condition': JSON.stringify(this.listQuery)
			};
			page(condition).then(response => {
				// 加载数据情况下
				var data = response.list;
				for(var i = 0; i < data.length; i++) {
					this.listData.push(data[i]);
				}
			});
		},
		// 进入明细
		itemClick(item) {
			if(item.id === null || item.id === undefined || item.id === '') {
				Toast({
					message: '还未填写预算信息！',
					position: 'middle',
					duration: 1500,
					className: 'info'
				});
				return;
			}
			var type = "1"; //  1: 全面预算 种类  2：人天预算 种类
			if(item.projTypeCate === '人天预算') {
				type = "2";
			}
			this.$router.push({
				name: '项目预算详情',
				params: {
					flag: '1',
					mainId: item.id,
					projStartDate: item.projStartDate,
					projEndDate: item.projEndDate,
					budgetType: type,
					ids: this.listQuery.ids,
					gobackName: this.gobackName
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/view/pm/budget/budgetList.vue